import React, {useState, useContext} from 'react';
import {Dimensions, View, LayoutChangeEvent, Platform} from 'react-native';

// export default {
//   window: {
//     width: Dimensions.get('window').width,
//     height: Dimensions.get('window').height,
//   },
// };

const DEFAULT_DIMENSIONS_CONTEXT_VALUE = {
  width: Dimensions.get('window').width,
  height: Dimensions.get('window').height,
};

const DIMENSIONS_CONTEXT = React.createContext(DEFAULT_DIMENSIONS_CONTEXT_VALUE);

export const DimensionsProvider: React.FC<{children?: React.ReactNode}> = ({children}) => {
  const [layout, setLayout] = useState(DEFAULT_DIMENSIONS_CONTEXT_VALUE);
  const [renderCount, setRenderCount] = useState(0);

  const handleLayout = ({nativeEvent}: LayoutChangeEvent) => {
    const {width, height} = nativeEvent.layout;

    if (renderCount === 0) {
      setLayout({width, height});
    }
    setRenderCount(renderCount + 1);
  };

  React.useLayoutEffect(() => {
    const updateSize = () => {
      setLayout({width: window.innerWidth, height: window.innerHeight});
    };
    if (Platform.OS === 'web') {
      window.addEventListener('resize', updateSize);
    }

    return () => {
      if (Platform.OS === 'web') {
        window.removeEventListener('resize', updateSize);
      }
    };
  }, []);

  if (Platform.OS === 'web') {
    return (
      <>
        <DIMENSIONS_CONTEXT.Provider value={layout}>{children}</DIMENSIONS_CONTEXT.Provider>
      </>
    );
  }

  return (
    <View onLayout={handleLayout} style={{flex: 1}}>
      <DIMENSIONS_CONTEXT.Provider value={layout}>{children}</DIMENSIONS_CONTEXT.Provider>
    </View>
  );
};

export const useDimensions = () => {
  const dimensions = useContext(DIMENSIONS_CONTEXT);
  return dimensions;
};
